import styled from 'styled-components';

export const CompanyAdditionForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1%;
`;

export const CompanyAdditionHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CompanyAdditionBody = styled.div`
  padding: 20px;
  border-radius: 20px;
  background: white;
`;

export const CompanyAdditionFormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
`;

export const CompanyAdditionFormRowLast = styled(CompanyAdditionFormRow)`
  flex-wrap: wrap;
  justify-content: end;
`;

export const CompanyAdditionForm1Row = styled(CompanyAdditionFormRow)`
  align-items: center; /* Align items vertically in the first row */
`;

export const CompanyAdditionFormRowleft = styled(CompanyAdditionFormRow)`
  width: 50%;
`;

export const CompanySideTextArea = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const CompanyLabel = styled.label`
  flex-basis: 30%;
  margin-top: 8px;
  margin-bottom: 5px;
  text-align: right;
`;

// import styled from 'styled-components';

// export const CompanyAdditionForm = styled.form`
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   padding: 1%;
// `;

// export const CompanyAdditionHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
// `;

// export const CompanyAdditionBody = styled.div`
//   padding: 20px;
//   border-radius: 20px;
//   background: white;
// `;
// export const CompanyAdditionFormRow = styled.div`
//   display: flex;
//   justify-content: space-between;
// `;
// export const CompanyAdditionFormRowLast = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   margin-bottom: 10px;
//   float: right;
// `;
// export const CompanyAdditionForm1Row = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   margin-bottom: 10px;
//   input {
//     width: 100%;
//     padding: 10px;
//     border: 1px solid #7f7f79;
//     border-radius: 5px;
//   }
// `;
// export const CompanyAdditionFormRowleft = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   margin-bottom: 10px;
//   float: left;
//   width: 50%;
// `;

// export const CompanySideTextArea = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   margin-bottom: 10px;
// `;
// export const Companylabel = styled.label`
//   display: flex;
//   justify-content: end;
//   margin-top: 8px;
//   flex-basis: 100%;
//   margin-bottom: 5px;
// `;
